import * as angular from "angular";
import {IController} from "angular";

export class AgentConfigurationProfileLink implements IController {
  profileRef: any;

  constructor() {
  }

  $onInit() {
  }
}

angular
  .module('bringoz.admin.configuration-profiles')
  .component('agentConfigurationProfileLink', {
    bindings: {
      profileRef: '<',
      agentType: '<?'
    },
    template: require('./agent-configuration-profile-link.html').default,
    controller: AgentConfigurationProfileLink
  });
